import { createSlice } from '@reduxjs/toolkit';
import { findSelectAdvertise, searchSelectAdvertise } from './api';
import { initialState } from './api/interface';

const selectAdvertiseSlice = createSlice({
  name: 'selectAdvertise',
  initialState,
  reducers: {
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
    },
    setHasMoreToFalse: (state, action) => {
      state.hasMore = action.payload.hasMore;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findSelectAdvertise.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findSelectAdvertise.fulfilled, (state, action) => {
      state.data.push(...action.payload.data);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
      state.hasMore = action.payload.data.length < 10 ? false : true;
    });
    builder.addCase(findSelectAdvertise.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(searchSelectAdvertise.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(searchSelectAdvertise.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
      state.hasMore = action.payload.data.length < 10 ? false : true;
    });
    builder.addCase(searchSelectAdvertise.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const { setSkip, setHasMoreToFalse, setStatus, reset } =
  selectAdvertiseSlice.actions;
export default selectAdvertiseSlice.reducer;
